import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'TopPopularFormats',
  setup(__props) {

/**
 * トップpage の「人気のテンプレート」ブロック。
 *
 * Top.vue の分解で切り出した表示専用ブロック。状態も手続きも持たない。
 * クリックは親 TopFormatList のデリゲーションが1箇所で受ける。
 *
 * スタイルは親 TopFormatList が :deep() で当てている（.format_link 等は
 * 「人気」「おすすめ」で共通なので、2重定義せず親に集約している）。
 * 見本リンク（.format_samples）はこのブロック専用なのでここに置く。
 */

return { __sfc: true, }
}

})